import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'fgb-facial-recognition-modal',
  templateUrl: './facial-recognition-modal.component.html',
  styleUrl: './facial-recognition-modal.component.scss',
})
export class FacialRecognitionModalComponent {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData: FormControl = new FormControl();
  @Input() isUploadInfo: boolean = false;
  @Input() goToStep: number;
  @Output() isUploadInfoChange = new EventEmitter<boolean>();
  @Output() setStep = new EventEmitter();
  @Output() nextStepChange = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
}
